import React from "react";

const getAddOnName = (addOn) => addOn?.add_on_details?.dish_name || addOn?.dish_name || "N/A";

const getAddOnPrice = (addOn) => addOn?.add_on_details?.price || addOn?.price || "0";

const OrderInvoiceItems = ({
  orderDishes = [],
  itemCellClass = "",
  qtyCellClass = "",
  priceCellClass = "",
  emptyCellClass = "",
}) => {
  if (!orderDishes.length) {
    return (
      <tr>
        <td colSpan="3" className={emptyCellClass || "text-center"}>
          No items found
        </td>
      </tr>
    );
  }

  return orderDishes.map((dish, index) => {
    const dishKey = dish?._id || `dish-${index}`;
    const sizeLabel = dish?.quantity_detail?.name;
    const dishName = dish?.menu_dish_details?.dish_name || "N/A";
    const itemLabel = sizeLabel ? `${dishName} (${sizeLabel})` : dishName;
    const addOns = dish?.add_ons || [];

    return (
      <React.Fragment key={dishKey}>
        <tr>
          <td className={itemCellClass}>{itemLabel}</td>
          <td className={qtyCellClass}>{dish?.quantity || 0}</td>
          <td className={priceCellClass}>£{dish?.item_total || "0"}</td>
        </tr>
        {addOns.map((addOn, addOnIndex) => (
          <tr key={`${dishKey}-addon-${addOn?._id || addOnIndex}`} className="order-invoice-addon-row">
            <td
              className={itemCellClass}
              style={{
                paddingLeft: "1.5rem",
                paddingTop: addOnIndex === 0 ? "0.35rem" : "0.1rem",
                paddingBottom: "0.1rem",
                verticalAlign: "top",
                lineHeight: 1.25,
              }}
            >
              {addOnIndex === 0 && (
                <small
                  className="text-muted d-block"
                  style={{ marginBottom: "2px", fontSize: "0.7rem", lineHeight: 1.2 }}
                >
                  Add Ons
                </small>
              )}
              {getAddOnName(addOn)}
            </td>
            <td
              className={qtyCellClass}
              style={{
                paddingTop: addOnIndex === 0 ? "0.35rem" : "0.1rem",
                paddingBottom: "0.1rem",
                verticalAlign: "top",
              }}
            >
              —
            </td>
            <td
              className={priceCellClass}
              style={{
                paddingTop: addOnIndex === 0 ? "0.35rem" : "0.1rem",
                paddingBottom: "0.1rem",
                verticalAlign: "top",
              }}
            >
              £{getAddOnPrice(addOn)}
            </td>
          </tr>
        ))}
      </React.Fragment>
    );
  });
};

export default OrderInvoiceItems;
